import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import LoadingSpinner from "./components/shared/LoadingSpinner";
import "./styles/shared/LoadingSpinner.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Global loading fallback for Suspense (i18n, lazy loading, etc.)
const GlobalFallback = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f6f8e4 0%, #e4f8e4 100%)'
  }}>
    <LoadingSpinner />
  </div>
);

// Only use StrictMode in development to avoid double API calls in production
const AppWrapper = process.env.NODE_ENV === 'development' ? (
  <React.StrictMode>
    <Suspense fallback={<GlobalFallback />}>
      <App />
    </Suspense>
  </React.StrictMode>
) : (
  <Suspense fallback={<GlobalFallback />}>
    <App />
  </Suspense>
);

root.render(AppWrapper);
